import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.slack-info', {
        url: '/slackInfo?state&code',
        component: 'companySlackInfo',
        resolve: {
            code,
            state,
        },
    })
}

/** @ngInject */
function code($stateParams) {
    return $stateParams.code;
}

/** @ngInject */
function state($stateParams) {
    return $stateParams.state;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/slack-info/slack-info.state.js